import { render, staticRenderFns } from "./LogoutSection.vue?vue&type=template&id=3f18a391&scoped=true&"
import script from "./LogoutSection.vue?vue&type=script&lang=js&"
export * from "./LogoutSection.vue?vue&type=script&lang=js&"
import style0 from "./LogoutSection.vue?vue&type=style&index=0&id=3f18a391&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f18a391",
  null
  
)

export default component.exports